import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
const _excluded = ["className", "visible"];
import app from '../../forum/app';
import UserPage from './UserPage';
import ItemList from '../../common/utils/ItemList';
import Switch from '../../common/components/Switch';
import Button from '../../common/components/Button';
import FieldSet from '../../common/components/FieldSet';
import NotificationGrid from './NotificationGrid';
import ChangePasswordModal from './ChangePasswordModal';
import ChangeEmailModal from './ChangeEmailModal';
import listItems from '../../common/helpers/listItems';
import extractText from '../../common/utils/extractText';
import classList from '../../common/utils/classList';
import ThemeMode from '../../common/components/ThemeMode';
import { camelCaseToSnakeCase } from '../../common/utils/string';
/**
 * The `SettingsPage` component displays the user's settings control panel, in
 * the context of their user profile.
 */
export default class SettingsPage extends UserPage {
  constructor() {
    super(...arguments);
    _defineProperty(this, "discloseOnlineLoading", void 0);
    _defineProperty(this, "colorSchemeLoading", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.show(app.session.user);
    app.setTitle(extractText(app.translator.trans('core.forum.settings.title')));
  }
  content() {
    return m("div", {
      className: "SettingsPage"
    }, m("ul", null, listItems(this.settingsItems().toArray())));
  }
  sectionProps() {
    return {
      account: {
        className: 'FieldSet--col'
      },
      colorScheme: {
        className: 'FieldSet--col',
        visible: () => app.allowUserColorScheme
      }
    };
  }

  /**
   * Build an item list for the user's settings controls.
   */
  settingsItems() {
    const items = new ItemList();
    ['account', 'notifications', 'privacy', 'colorScheme'].forEach((section, index) => {
      const sectionItems = "".concat(section, "Items");
      const _ref = this.sectionProps()[section] || {},
        {
          className,
          visible
        } = _ref,
        props = _objectWithoutProperties(_ref, _excluded);
      if (visible && visible() === false) return;
      items.add(section, m(FieldSet, Object.assign({
        className: classList("Settings-".concat(section, " FieldSet--min"), className || ''),
        label: app.translator.trans("core.forum.settings.".concat(camelCaseToSnakeCase(section), "_heading"))
      }, props), this[sectionItems]().toArray()), 100 - index * 10);
    });
    return items;
  }

  /**
   * Build an item list for the user's account settings.
   */
  accountItems() {
    const items = new ItemList();
    items.add('changePassword', m(Button, {
      className: "Button",
      onclick: () => app.modal.show(ChangePasswordModal)
    }, app.translator.trans('core.forum.settings.change_password_button')), 100);
    items.add('changeEmail', m(Button, {
      className: "Button",
      onclick: () => app.modal.show(ChangeEmailModal)
    }, app.translator.trans('core.forum.settings.change_email_button')), 90);
    return items;
  }

  /**
   * Build an item list for the user's notification settings.
   */
  notificationsItems() {
    const items = new ItemList();
    items.add('notificationGrid', m(NotificationGrid, {
      user: this.user
    }), 100);
    return items;
  }

  /**
   * Build an item list for the user's privacy settings.
   */
  privacyItems() {
    var _preferences;
    const items = new ItemList();
    items.add('discloseOnline', m(Switch, {
      state: (_preferences = this.user.preferences()) == null ? void 0 : _preferences.discloseOnline,
      onchange: value => {
        this.discloseOnlineLoading = true;
        this.user.savePreferences({
          discloseOnline: value
        }).then(() => {
          this.discloseOnlineLoading = false;
          m.redraw();
        });
      },
      loading: this.discloseOnlineLoading
    }, app.translator.trans('core.forum.settings.privacy_disclose_online_label')), 100);
    return items;
  }

  /**
   * Color schemes.
   */
  colorSchemeItems() {
    const items = new ItemList();
    ThemeMode.colorSchemes.forEach(mode => {
      var _preferences2;
      items.add(mode.id, m(ThemeMode, {
        mode: mode.id,
        label: mode.label || app.translator.trans('core.forum.settings.color_schemes.' + mode.id.replace('-', '_') + '_mode_label'),
        selected: ((_preferences2 = this.user.preferences()) == null ? void 0 : _preferences2.colorScheme) === mode.id,
        loading: this.colorSchemeLoading,
        onclick: () => {
          this.colorSchemeLoading = true;
          this.user.savePreferences({
            colorScheme: mode.id
          }).then(() => {
            this.colorSchemeLoading = false;
            app.setColorScheme(mode.id);
            m.redraw();
          });
        }
      }), 100);
    });
    return items;
  }
}
flarum.reg.add('core', 'forum/components/SettingsPage', SettingsPage);